// extracted by css-extract-rspack-plugin
export default {"toggletip":"toggletip-2GgtE","arrow":"arrow-LbP9Q"};